import { computed, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SmartBannerService } from '@main/smart-banner/feature';
import { DeviceService } from '@shared/services';
import { WindowRef } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class CookieAgreementService {
  private readonly winRef = inject(WindowRef);
  private readonly deviceService = inject(DeviceService);
  private readonly smartBannerService = inject(SmartBannerService);

  private readonly modalState = signal<boolean>(true);

  private readonly isDesktop = toSignal(this.deviceService.isDesktopLgUp$, { initialValue: false });
  private readonly isTabletMdDown = toSignal(this.deviceService.isTabletMdDown$, { initialValue: false });

  readonly showCookies = computed(() => {
    const modalState = this.modalState();
    const isDesktop = this.isDesktop();
    const isTabletMdDown = this.isTabletMdDown();
    const isVisible = this.smartBannerService.showSmartBanner();

    if (!modalState) {
      return false;
    }

    // на деске показываем сразу
    if (isDesktop) {
      return true;
    }

    // на мобилках/планшетах если баннер не показывается или уже закрыт
    if (isTabletMdDown) {
      return !isVisible;
    }

    return false;
  });

  checkAgreement(): void {
    if (this.deviceService.isSdvorAppIos() || this.deviceService.isSdvorAppV2()) {
      this.modalState.set(false);

      return;
    }

    if (this.winRef.localStorage?.getItem('cookies_agreement')) {
      this.modalState.set(false);
    }
  }

  getModalState(): WritableSignal<boolean> {
    this.checkAgreement();

    return this.modalState;
  }

  syncLocalStorage(value: boolean): void {
    this.winRef.localStorage?.setItem('cookies_agreement', String(value));
  }

  setState(value: boolean): void {
    this.modalState.set(value);
    this.syncLocalStorage(!value);
  }
}
